var UitkLayoutPositionPointerEventsMap = [['none', 'pointerevents-none']];
var UitkLayoutPositionPointerEvents = new Map(UitkLayoutPositionPointerEventsMap);
var UitkLayoutPositionTypeMap = [
    ['relative', 'relative'],
    ['sticky', 'sticky'],
    ['absolute', 'absolute'],
    ['fixed', 'fixed']
];
var UitkLayoutPositionTypes = new Map(UitkLayoutPositionTypeMap);

export { UitkLayoutPositionPointerEvents, UitkLayoutPositionTypes };
